import React from 'react';
import jet from "@randajan/jet-core";

import "./PagePop.scss";
import { usePagePop } from '../../hooks/usePagePop';
import { Button } from '@randajan/jet-react/dom/form';



export const PagePop = (props)=>{
    const { caption, hash, children, className } = props;
    const pop = usePagePop(hash, children);

    const propsPass = Object.jet.exclude(props, ["caption", "hash", "children", "className"]);
    
    return (
        <Button className={jet.melt(["PagePop", className])} {...propsPass} onSubmit={_=>pop.up()}>
            {caption}
        </Button>
    )
}

